import _ from 'lodash'
import { createSelector } from '@reduxjs/toolkit'
import accountApi from 'Services/account'

export const getAccountDetails = (state) => _.get(state, 'account', {})
export const getDefaultPermissions = (state) => {
  const accountInfo = getAccountDetails(state)
  return accountInfo.permissions || {}
}

export const getAccountSettings = (state) => {
  const info = getAccountDetails(state)
  return info.settings || {}
}

export const getAccountFeatures = (state) => {
  const settings = getAccountSettings(state)
  return settings.features || {}
}

export const getApps = (state) => {
  const info = getAccountDetails(state)
  return info.apps ?? []
}

/** Account feautres: START */
export const getIsMultiFlowFeatureSupported = (state) => {
  const accountFeatures = getAccountFeatures(state)
  return accountFeatures.multiflow ?? false
}
/** Account feautres: END */

/**
 * Account from RTK state
 */
export const $getAccountDetails = (state) => {
  return accountApi.endpoints.getAccount.select()(state)?.data ?? {}
}

export const $getAccountSettings = createSelector([$getAccountDetails], (accountDetails) => {
  return accountDetails?.settings || {}
})

export const $getAccountFeatures = createSelector([$getAccountSettings], (accountSettings) => {
  return accountSettings?.features || {}
})

export const $getIsInternalFeatureSupported = createSelector([$getAccountFeatures], (accountFeatures) => {
  return accountFeatures.internal || false
})
